import React, {Component} from 'react'
import {
  StyleSheet,
  View,
  Dimensions,
  ScrollView,
  ActivityIndicator,
  Alert,
} from 'react-native'
import {Text, Input, Button} from 'react-native-elements'

import List from './List'
import Create from './Create'
import Update from './Update'
import Delete from './Delete'

class Admin extends Component {
  constructor (props) {
    super(props)
    this.state = {
      viewType: 0,
      id: null,
    }
  }
  onCreatePress = () => {
    this.setState({
      viewType: 1,
    })
  }
  onUpdatePress = id => {
    this.setState({
      viewType: 2,
      id: id,
    })
  }
  onDeletePress = id => {
    this.setState({
      viewType: 3,
      id: id,
    })
  }

  onCreateCancelPress = () => {
    this.setState({
      viewType: 0,
    })
  }
  onUpdateCancelPress = () => {
    this.setState({
      viewType: 0,
    })
  }

  onDeleteCancelPress = () => {
    this.setState({
      viewType: 0,
    })
  }

  render () {
    return this.state.viewType == 1 ? (
      <Create onCreateCancelPress={this.onCreateCancelPress} />
    ) : this.state.viewType == 2 ? (
      <Update
        id={this.state.id}
        onUpdateCancelPress={this.onUpdateCancelPress}
      />
    ) : this.state.viewType == 3 ? (
      <Delete
        id={this.state.id}
        onDeleteCancelPress={this.onDeleteCancelPress}
      />
    ) : (
      <List
        onCreatePress={this.onCreatePress}
        onUpdatePress={this.onUpdatePress}
        onDeletePress={this.onDeletePress}
      />
    )
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 10,
  },
  headStyle: {
    borderRadius: 10,
  },
  dataText: {margin: 10, color: 'black'},
  headingTextStyle: {
    color: '#007599',
    fontSize: 20,
    fontWeight: 'bold',
    margin: 6,
    color: '#007599',
  },
  row: {flexDirection: 'row', backgroundColor: '#ffffff'},
  buttonStyle: {
    width: 70,
    height: 30,
    backgroundColor: '#007599',
    borderRadius: 2,
  },
  buttonTitleStyle: {
    color: 'white',
    fontSize: 15,
  },
})

export default Admin
